<ng-template #vendorNoteModal let-modal>
    <form name="form" #noteModalF="ngForm" (ngSubmit)="noteModalF.form.valid && addNote(noteModalF)" novalidate
        *blockUI="'container-blockui-note'">
        <div class="modal-header">
            <h5 class="modal-title">Add Note</h5>
            <button type="button" class="close" aria-label="Close" (click)="closeVendorNoteModal(noteModalF)">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="col-md-12">
                <div class="form-group"
                    [ngClass]="{ 'validation-error' : noteModalF.submitted && vendorNote.invalid}">
                    <label class="control-label">Note *</label>
                    <textarea name="vendorNote" class="form-control" maxlength="300" rows="3" autocomplete="Off"
                        [(ngModel)]="note" #vendorNote="ngModel" required>
                        </textarea>
                    <div class="validation-error-message" *ngIf="noteModalF.submitted && vendorNote.invalid">
                        Note is required
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <div class="col-md-12 text-right">
                <button type="button" class="btn btn-default m-r-5"
                    (click)="closeVendorNoteModal(noteModalF)">Close</button>
                <button type="submit" class="btn btn-primary">Submit</button>
            </div>
        </div>
    </form>
</ng-template>